export type CustomerStatusFilter = 'all' | 'active' | 'inactive';

export interface CustomerAddress {
  pincode?: string;
  country?: string;
  state?: string;
  city?: string;
  address?: string;
  landmark?: string;
}

export interface CustomerStats {
  totalOrders: number;
  totalSpent: number;
  totalReviews: number;
}

export interface Customer {
  id: string;
  firstName: string;
  lastName: string;
  name: string;
  email: string;
  profileImage?: string;
  avatar?: string;
  address?: CustomerAddress | null;
  isActive: boolean;
  lastLoginAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedCustomers {
  results: Customer[];
  total: number;
  page: string | number;
  limit: string | number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export interface CustomerListParams {
  page?: number;
  limit?: number;
  search?: string;
  email?: string;
  city?: string;
  state?: string;
  pincode?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  status?: 'active' | 'inactive';
  joinedFrom?: string;
  joinedTo?: string;
}

export interface CustomerDetail extends Customer {
  stats: CustomerStats;
}

export interface CustomerAddressPayload {
  pincode: string;
  country: string;
  state: string;
  city: string;
  address: string;
  landmark?: string;
}

export interface CreateCustomerPayload {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  address: CustomerAddressPayload;
  isActive?: boolean;
}

export interface UpdateCustomerPayload {
  firstName?: string;
  lastName?: string;
  email?: string;
  address?: CustomerAddressPayload;
  isActive?: boolean;
}

export interface BulkCustomerIdsPayload {
  ids: string[];
}

export interface BulkCustomerStatusPayload extends BulkCustomerIdsPayload {
  isActive: boolean;
}

export function formatCustomerLocation(address?: CustomerAddress | null): string {
  if (!address) return '—';
  const parts = [address.city, address.state].filter(Boolean);
  return parts.length ? parts.join(', ') : '—';
}

export function formatCustomerAddressLine(address?: CustomerAddress | null): string {
  if (!address?.address) return '—';
  const parts = [address.address, address.landmark].filter(Boolean);
  return parts.join(', ');
}
